import React from 'react'

import { Col, Form, Switch } from 'antd'
import _ from 'lodash'

import { getMessage } from '../../util/IntlMessages'

const CustomSwitch = function ({
  checkedChildren,
  defaultValue = false,
  disabled,
  errors = {},
  field,
  loading,
  onChange,
  rowSpan,
  setFieldValue,
  suffixLabel,
  unCheckedChildren,
  removeLabel,
  value
}) {
  const label = removeLabel ? '' : `${getMessage(field)}${suffixLabel ? ' '.concat(suffixLabel) : ''}`

  return (
    <Col span={rowSpan}>
      <Form.Item label={label} validateStatus={errors[field] ? 'error' : 'validating'} help={errors[field]}>
        <Switch
          checked={_.isBoolean(value[field]) ? value[field] : defaultValue}
          checkedChildren={checkedChildren === null ? '' : checkedChildren}
          defaultChecked={defaultValue}
          disabled={disabled || false}
          loading={loading || false}
          name={field}
          onChange={(value, defaultValue) => {
            const setValue = value === null ? defaultValue : value
            setFieldValue(field, setValue)
            if (onChange) {
              onChange(setValue)
            }
          }}
          placeholder={getMessage('switch')}
          unCheckedChildren={unCheckedChildren === null ? '' : unCheckedChildren}
        />
      </Form.Item>
    </Col>
  )
}

export default React.memo(CustomSwitch)
